import Vue from "vue";
import Component from 'vue-class-component';
import * as Http from './../shared/http';

@Component
export default class Confirm extends Vue {
}